export var imageBasePath = 'https://ik.imagekit.io/onsnhxjshmp';
//# sourceMappingURL=imagekitBasePath.js.map